var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.component,_vm._g(_vm._b({tag:"component",staticClass:"btn"},'component',_vm.$attrs,false),_vm.$listeners),[_vm._t("iconLeft"),_c('div',{staticClass:"inner"},[_vm._t("default")],2),_vm._t("iconRight")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }